import script from "./EditorOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorOrder.vue?vue&type=script&setup=true&lang=js"

import "./EditorOrder.vue?vue&type=style&index=0&id=00de4e1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00de4e1a"]])

export default __exports__